import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../Header";
import LogoCarousel from "../Logo";
import TestimonialsCarousel from "../TestimonialsCarousel";
import EagleSection from "../EagleSection";
import FooterWithMenu from "../Footer";
import blogPosts from "../../data/blogPosts";

// Maps the blogPosts.js category strings to the tabs displayed on this page.
const categoryToTab = {
  "UX / UI": "UI/UX",
  "Branding": "Graphic design",
  "Digital Growth": "Digital Marketing",
  // "Video editing" tab has no posts assigned yet.
};

const CaseStudy = () => {
  const tabs = ["UI/UX", "Graphic design", "Video editing", "Digital Marketing"];
  const [selectedTab, setSelectedTab] = useState("UI/UX");
  const [isFiltering, setIsFiltering] = useState(false);

  // Convert each blog post into a card payload for the grid.
  const allCards = blogPosts.map((post) => ({
    id: "blog-" + post.id,
    title: post.title,
    description: post.excerpt,
    img: post.cardImage?.src || post.heroImage?.src,
    blogSlug: post.slug,
    tab: categoryToTab[post.category] || null,
  }));

  const filteredCards = allCards.filter((c) => c.tab === selectedTab);

  const handleTabSelect = (tab) => {
    setIsFiltering(true);
    setTimeout(() => {
      setSelectedTab(tab);
      setIsFiltering(false);
    }, 250);
  };

  return (
    <>
      <Header />

      <div
        className="container mx-auto px-4 md:px-20 py-12 z-0"
        style={{ backgroundImage: "url('/assets/svg/plain_dot.svg')" }}
      >
        <img
          src="/assets/png/gradient.png"
          alt=""
          aria-hidden="true"
          className="z-0 absolute top-[0%] w-full h-full left-[0%]"
        />

        <h2 className="text-5xl md:text-6xl text-center font-medium leading-extra-loose text-gray-800 pt-10 font-inter relative z-10">
          Case <span className="text-[#F15A28]">Studies</span>
        </h2>

        {/* Tab filter bar */}
        <div className="text-center my-12 relative z-10">
          <div className="flex flex-wrap justify-center md:justify-between gap-2 w-full md:w-[87%] mx-auto border-[1px] border-gray-500 px-2 py-2 rounded-2xl md:rounded-3xl bg-white/40 backdrop-blur-sm">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => handleTabSelect(tab)}
                className={
                  "flex-1 min-w-[120px] px-4 py-2 md:px-6 md:py-4 mx-1 my-1 font-inter font-medium text-base md:text-lg text-black rounded-xl transition-all duration-300 " +
                  (selectedTab === tab
                    ? "bg-[#F15A28] text-white hover:bg-[#F15A28]"
                    : "hover:bg-[#F15A28] hover:text-white")
                }
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Cards grid */}
        <div
          className={
            "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-10 transition-opacity duration-300 relative z-10 " +
            (isFiltering ? "opacity-50" : "opacity-100")
          }
        >
          {filteredCards.length === 0 ? (
            <div className="col-span-full text-center py-16">
              <p className="text-lg md:text-xl text-gray-600 font-poppins">
                No case studies in this category yet. Check back soon.
              </p>
            </div>
          ) : (
            filteredCards.map((card) => (
              <Link
                key={card.id}
                to={"/blog/" + card.blogSlug}
                className="relative group overflow-hidden rounded-lg border-[1px] bg-white block hover:shadow-lg transition-shadow"
              >
                {card.img && (
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-60 object-cover transform transition-all duration-300 p-1 rounded-2xl"
                  />
                )}
                <div className="px-4 py-3 bg-white">
                  <h3 className="text-xl font-bold text-gray-800 font-poppins leading-10">
                    {card.title}
                  </h3>
                  <p className="text-sm text-gray-600 font-poppins font-normal leading-5">
                    {card.description}
                  </p>
                </div>
              </Link>
            ))
          )}
        </div>
      </div>

      <LogoCarousel />
      <TestimonialsCarousel />
      <EagleSection />
      <FooterWithMenu />
    </>
  );
};

export default CaseStudy;
